import { RouteConfig } from 'vue-router';
import useI18n from '@/mixins/useI18n';
import About from '@/views/public/about/About.vue';

const { t } = useI18n();

const routes: RouteConfig[] = [
  {
    name: 'about',
    path: '/about',
    component: About,
    meta: {
      layout: 'landingpage',
      title: t('about.meta.title'),
      description: t('about.meta.description'),
    }
  }
];

export default routes;
